angular.module('SpidApp')

.constant('BusinessDayAdapterConfig', {
  name : 'BusinessDay',
  fields : [
    {
    	local   : 'date',
    	distant : 'date'
    }, {
    	local   : 'cash',
    	distant : 'cash'
    }, {
    	local   : 'sum',
    	distant : 'sum'
    }, {
    	local   : 'agency_id',
    	distant : 'agency_id'
    }, {
    	local   : 'validated',
    	distant : 'validated'
    }, {
    	local   : 'updated_at',
    	distant : 'updated_at'
    }
  ]
})
